import { NgModule } from '@angular/core';
import { BookingLinkModule } from './booking-link/booking-link.module';
import { GroupModule } from './group/group.module';
import { MeetingListModule } from './meeting-list/meeting-list.module';
import { MeetingSchedulerSharedModule } from './shared/meeting-scheduler-shared.module';
import { MeetingSchedulerSettingsModule } from './schedule-settings/schedule-settings.module';
import { RescheduleMeetingButtonModule } from './meeting-actions/reschedule/reschedule-meeting-button.module';
import { CancelMeetingButtonModule } from './meeting-actions/cancel/cancel-meeting-button.module';
import { MeetingIntegrationsModule } from './meeting-integrations/meeting-integrations.module';
import { MeetingTypeModule } from './meeting-type/meeting-type.module';
import { NavigationModule } from './sales-center-navigation/navigation.module';
import { ServiceModule } from './service/service.module';
import { MeetingTypeListViewModule } from './meeting-type-list-view/meeting-type-list-view.module';

const IMPORTS_AND_EXPORTS = [
  BookingLinkModule,
  MeetingListModule,
  MeetingSchedulerSharedModule,
  MeetingSchedulerSettingsModule,
  RescheduleMeetingButtonModule,
  CancelMeetingButtonModule,
  MeetingIntegrationsModule,
  MeetingTypeModule,
  GroupModule,
  ServiceModule,
  MeetingTypeListViewModule,
];

@NgModule({
  declarations: [],
  imports: [...IMPORTS_AND_EXPORTS, NavigationModule],
  exports: IMPORTS_AND_EXPORTS,
})
export class MeetingSchedulerComponentsModule {}
